import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-apollo'

import { getGQLErrorMsg } from '../../../../lib/apollo'
import { CardWrapper, CardContent, CardInnerHeading } from '../../../shared/settings/card'
import Toggle from '../../../shared/settings/toggle'
import {
  PIN_SETTINGS_HEADER,
  PIN_SETTINGS_TOOLTIP,
  PIN_SETTINGS_SWITCH_PROFILE_TEXT,
  PIN_SETTINGS_SWITCH_PROFILE_SUBTEXT,
  PIN_SETTINGS_MANAGE_PROFILE_TEXT,
  PIN_SETTINGS_MANAGE_PROFILE_SUBTEXT
} from '../constants'

import ACCOUNT_QUERY from '../../../../../graphql/queries/account.gql'
import ACCOUNT_MUTATION from '../../../../../graphql/mutations/account.gql'

import styles from './pin-settings.css'

export default function PinSettings() {
  const [error, setError] = useState('')
  const {
    data: accountData,
    loading: accountLoading,
    error: accountError
  } = useQuery(ACCOUNT_QUERY)
  const [updateAccount] = useMutation(ACCOUNT_MUTATION)

  const account = accountData?.account

  if (accountLoading || accountError || !account || !account.settings) {
    return null
  }

  const getSetting = setting => account.settings && account.settings[setting]
  const requirePinForManageProfile = getSetting('requirePinForManageProfile')
  const requirePinForSwitchProfile = getSetting('requirePinForSwitchProfile')
  const hasPin = account.hasPin
  const tooltipText = !hasPin ? PIN_SETTINGS_TOOLTIP : ''

  const updateAccountSetting = (setting, checked) => {
    updateAccount({
      variables: {
        input: {
          settings: {
            [setting]: checked
          }
        }
      },
      optimisticResponse: {
        __typename: 'Mutation',
        account: {
          __typename: 'Account',
          ...account,
          settings: {
            __typename: 'AccountSettings',
            ...account.settings,
            [setting]: checked
          }
        }
      },
      update: (proxy, response) => {
        const data = proxy.readQuery({ query: ACCOUNT_QUERY })
        proxy.writeQuery({
          query: ACCOUNT_QUERY,
          data: {
            ...data,
            account: {
              ...data.account,
              settings: {
                ...data.account.settings,
                [setting]: response.data.account.settings[setting]
              }
            }
          }
        })
      }
    }).catch(mutationError => {
      setError(getGQLErrorMsg(mutationError))
    })
  }

  const onToggleChange = (event) => {
    updateAccountSetting(event.target.value, event.target.checked)
  }

  return (
    <CardWrapper>
      <CardContent className={styles.cardContent}>
        <CardInnerHeading
          className={styles.cardInnerHeading}
          header={PIN_SETTINGS_HEADER}
        />
        <Toggle
          wrapperClassName={styles.changeProfile}
          textWrapperClassName={styles.textWrapperClass}
          containerClassName={styles.toggleTextClass}
          text={PIN_SETTINGS_SWITCH_PROFILE_TEXT}
          subText={PIN_SETTINGS_SWITCH_PROFILE_SUBTEXT}
          toggleText={requirePinForSwitchProfile ? 'On' : 'Off'}
          value="requirePinForSwitchProfile"
          checked={requirePinForSwitchProfile}
          onChange={onToggleChange}
          disabled={!hasPin}
          tooltipText={tooltipText}
        />
        <Toggle
          wrapperClassName={styles.toggleWrapperClass}
          textWrapperClassName={styles.textWrapperClass}
          containerClassName={styles.toggleTextClass}
          text={PIN_SETTINGS_MANAGE_PROFILE_TEXT}
          subText={PIN_SETTINGS_MANAGE_PROFILE_SUBTEXT}
          toggleText={requirePinForManageProfile ? 'On' : 'Off'}
          value="requirePinForManageProfile"
          checked={requirePinForManageProfile}
          onChange={onToggleChange}
          disabled={!hasPin}
          tooltipText={tooltipText}
        />
        {error && <div className={styles.warningMessage}>{error}</div>}
      </CardContent>
    </CardWrapper>
  )
}
